(() => {
  'use strict';

  const GLOBAL_FLAG = '__entrevoltasFilterPolishLoaded';
  if (window[GLOBAL_FLAG]) return;
  window[GLOBAL_FLAG] = true;

  const ROOT_SELECTORS = [
    '#FacetsWrapperDesktop',
    '#FacetsWrapperMobile',
    '.active-facets-desktop',
    '.active-facets-mobile'
  ];

  const replaceText = (root) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      if (node.nodeValue && node.nodeValue.includes('Tipo - Estilo')) {
        node.nodeValue = node.nodeValue.replaceAll('Tipo - Estilo', 'Modelagem');
      }
    });

    root.querySelectorAll?.('[aria-label]').forEach((element) => {
      const aria = element.getAttribute('aria-label');
      if (aria && aria.includes('Tipo - Estilo')) {
        element.setAttribute('aria-label', aria.replaceAll('Tipo - Estilo', 'Modelagem'));
      }
    });
  };

  const polish = (root = document) => {
    ROOT_SELECTORS.forEach((selector) => {
      if (root.matches?.(selector)) replaceText(root);
      root.querySelectorAll?.(selector).forEach(replaceText);
    });
  };

  let scheduled = null;

  const schedulePolish = () => {
    if (scheduled) window.clearTimeout(scheduled);

    scheduled = window.setTimeout(() => {
      scheduled = null;
      polish(document);
    }, 30);
  };

  const observer = new MutationObserver((mutations) => {
    const hasStructureChange = mutations.some(
      (mutation) => mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)
    );

    if (hasStructureChange) schedulePolish();
  });

  const init = () => {
    polish(document);

    const target = document.querySelector('.facets-container') || document.body;
    observer.observe(target, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', schedulePolish);
  window.addEventListener('popstate', schedulePolish);
})();